// extracted by mini-css-extract-plugin
export default {"grid":"clients_grid__aY5ET"};